const _baseUrl = process.env.VUE_APP_LOGIC
export default {
  getUser () {
    return _baseUrl + 'api/v2/users/@me'
  },
  getRegistered (ctcode,phone) {
    return _baseUrl + 'api/v1/phones-registered/' + ctcode + '-' + phone
  },
  getCaptcha (ctcode, phone) {
    return _baseUrl + 'api/v1/phone-captchas/' + ctcode + '-' + phone
  },
  getToken () {
    return _baseUrl + 'api/v1/tokens'
  },
  deleteToken () {
    return _baseUrl + 'api/v2/tokens/@current'
  },  
  // 获取号段
  getCtcodes () {
    return _baseUrl + 'api/v1/ctcodes'
  },
  // 获取客户端配置
  getClientSettings (version) {
    return _baseUrl + 'api/' + version + '/client-settings/@current'
  },
  getRedUserInfo () {
		return _baseUrl + 'api/v2/user_red_packet_info'
	},
	getRedRank () {
		return _baseUrl + 'api/v2/get_red_packet_host_rank_list'
  },
  //关注用户
  postFollows() {
    return _baseUrl + 'api/v2/follows'
	},
	//取消关注
  deleteFollows() {
    return _baseUrl + 'api/v2/follows'
  },
	// 查询用户之间关系
  getUserRelTypes(uid) {
    return _baseUrl + 'api/v2/users/@me/user_rel_types/' + uid
  },
  // 获取临时token
  getAuthTokenCG () {
    return _baseUrl + 'api/v2/auth-token'
	},
}
